import { Kanjis } from './kanji-randomizer.interface';
import { JoyoKanji } from '../kanji';

export const joyoKanjis: Kanjis = Object.entries(JoyoKanji).map(e => e[1]);
